module.exports = __webpack_public_path__ + "static/media/MK.c62e5818.svg";